/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data ids used in the event subscription builder form.
 * @export
 */
export const EVENT_SUBSCRIPTION_BUILDER_DATA_IDS = {
  actionMenu: `Button: Event subscription action menu`,
  addAttribute: `Button: Add attribute filter`,
  apiKey: `Form field: API key`,
  attributeFilterName: `Form field: Attribute filter name`,
  attributeFilterRule: `Form field: Attribute filter rule`,
  attributeFilterValue: `Form field: Attribute filter value`,
  cancelButton: `Button: Cancel creating an event subscription`,
  contextName: `Form field: Context name required`,
  createButton: `Button: Create event subscription button`,
  deleteButton: `Menu button: Action menu delete button`,
  eventType: `Form field: Event subscription event type`,
  jobName: `Form field: Job name required`,
  saveButton: `Button: Save event subscription button`,
  scheduler: `Row: Event scheduler`,
  schedulerOptionOnce: `Radio button: Event scheduler - Once`,
  schedulerOptionRecurring: `Radio button: Event scheduler - Recurring`,
  subscriptionDetails: `Row: Event subscription details`,
  subscriptionName: `Form field: Event subscription name`,
  subscriptionSource: `Form field: Event subscription source`,
  targetDetails: `Row: Event subscription target details`,
  targetType: `Form field: Target type`,
  tryAgainButton: `Button: Try again button`,
  urlRequired: `Form field: URL required`,
};

/**
 * The field ids used in the event subscription builder form.
 * @export
 */
export const EVENT_SUBSCRIPTION_BUILDER_FORM_IDS = {
  apiKey: `subscription-target-api-key`,
  attribute: `subscription-target-attribute-name`,
  attributeRule: `subscription-target-attribute-rule`,
  contextName: `subscription-target-context-name`,
  dateTimePicker: `scheduler-datetime-picker`,
  eventPathsMap: `api-target-event-paths-map`,
  eventTemplate: `api-target-event-template`,
  flowInput: `flow-input-json`,
  jobName: `subscription-target-job-name`,
  ruleMatchingLogic: `attribute-filters-rule-matching-logic`,
  schedulerType: `scheduler-type`,
  subscriptionEventType: `subscription-event-type`,
  subscriptionName: `subscription-name`,
  subscriptionSource: `subscription-source`,
  targetType: `subscription-target-type`,
  url: `subscription-target-url`,
};

/**
 * The ids of the event transformer form fields.
 * @export
 */
export const EVENT_TRANSFORMER_FORM_IDS = [
  EVENT_SUBSCRIPTION_BUILDER_FORM_IDS.eventPathsMap,
  EVENT_SUBSCRIPTION_BUILDER_FORM_IDS.eventTemplate,
];

/**
 * An api key value is required to create an event subscription target
 * even if the target connection has no authorisation required.
 * @export
 */
export const DUMMY_KEY_NO_AUTH_REQUIRED = `DUMMY_KEY_NO_AUTH_REQUIRED`;

/**
 * The AU tenant Connect Webhook URL is required to compare the
 * user-inputted URL to check whether it's a Connect Webhook URL.
 * @export
 */
export const AU_CONNECT_WEBHOOK_URL = `https://in.au.connect.squiz.cloud/hook`;

/**
 * The US tenant Connect Webhook URL is required to compare the
 * user-inputted URL to check whether it's a Connect Webhook URL.
 * @export
 */
export const US_CONNECT_WEBHOOK_URL = `https://in.connect.squiz.cloud/hook`;

/**
 * The job runner URL path is required to check if the url loaded when loading
 * event subscription form is a job runner url to depict the correct target type
 * @export
 */
export const JOB_RUNNER_URL_PATH = `job-runner`;

/**
 * The job runner executions endpoint is required to check if the url loaded when loading
 * event subscription form is a job runner url to depict the correct target type
 * @export
 */
export const JOB_RUNNER_EXECUTIONS_ENDPOINT = `/executions/begin`;
